import { useState, useEffect } from 'react';
import { useTheme } from '../stores/theme-store';

// Light theme backgrounds (3 images)
const LIGHT_BACKGROUNDS = [
  '/images/backgrounds/light/login-background.jpg',
  '/images/backgrounds/light/DSC_9261_Copy_6d028ffe4a.jpg',
  '/images/backgrounds/light/Photo_1753628877858_a1a2017e9e.jpg',
];

// Dark theme backgrounds (6 images)
const DARK_BACKGROUNDS = [
  '/images/backgrounds/dark/01_23_ea3ba29d98.jpg',
  '/images/backgrounds/dark/4ggy8whzzdvpegdwol84yqm02ec5mgjg_643f03c297.jpg',
  '/images/backgrounds/dark/DSC_1198_copy_eafd27f482.jpg',
  '/images/backgrounds/dark/DSC_08279_c0fc6ef8e2.jpg',
  '/images/backgrounds/dark/DSC_1859_3240a1ccf0.jpg',
  '/images/backgrounds/dark/DSC_8080_copy_ab1def3518.jpg',
];

/**
 * Hook to get a random background image based on active resolved theme
 * @returns {string} Path to the background image
 */
export const useRandomBackground = (): string => {
  const { resolvedTheme } = useTheme();
  const [background, setBackground] = useState<string>('');

  useEffect(() => {
    const isDark = resolvedTheme === 'dark';
    const backgrounds = isDark ? DARK_BACKGROUNDS : LIGHT_BACKGROUNDS;
    const randomIndex = Math.floor(Math.random() * backgrounds.length);
    setBackground(backgrounds[randomIndex]);
  }, [resolvedTheme]);

  return background;
};
